// eslint-disable-next-line
export const allowOnlyNumbers = (_rule: any, value: any) => {
  if (!(value > 0)) {
    return Promise.reject("Number must be greater than 0");
  }
  return Promise.resolve();
};
